import axios from 'axios'
import auth from '../util/auth'
import router from '../router'
import { Message } from 'iview'
import { requestFilter , requireNoticeCode } from './code'
import apis from './apis'

const methods = ['post','get','put','head','delete','patch']

const apiServer = process.env.NODE_ENV == 'development' ?  localStorage.getItem('server') : null

const baseURL =  '/api' + ( apiServer ? ('/' + apiServer ) : '')

axios.defaults.timeout = 20 * 1000
axios.defaults.baseURL = baseURL

const service = axios.create()
const service_raw = axios.create()

const log = (content , type = 'error')=>(Message[type]({content}))

const convFormData = (data) => {
  let fd = new FormData()
  for(let i in data){
    if(Array.isArray(data[i])){
      let item = []
      data[i].forEach((j,idx) => {
        fd.append(`${i}[${idx}]` , j)
      })
    }else{
      fd.append(i , data[i])
    }
  }
  return fd
}

const clearEmptyData = (data , field) => {
  let p = data , k = field.split('.')
  for(let i = 0; i<k.length; i++){
    if( k[i] in p ){
      p = p[k[i]];
    }else{
      break;
    }
  }
  
  for(let j in p){
    if(p[j] === '') p[j] = null
  }

  return data
}
// http response 拦截器
service.interceptors.response.use(
  response => {
    //http error code
    if(response.data.status){
      log(`${ response.data.message || response.data.msg}`)
      response.data.code = -2
      response.data.msg = response.data.message
      
      return response.data
    }

    else if(requestFilter.includes(response.data.code)){
      auth.clear()

      // log(`[${response.data.code}]${ response.data.message || response.data.msg}`)
      log(`${ response.data.message || response.data.msg}`)

      router.push({name:'signin' , replace:true})

      return response.data
      
    }

    else if(response.data.code != 0){
      if(response.data.message){
        response.data.msg = response.data.message
      }

      if(requireNoticeCode.includes(response.data.code)){
        log(`${ response.data.message || response.data.msg}`)
      }
      return response.data

    }

    else{
      return response.data
    }

  },

  error => {
    // 由接口返回的错误
    if (error.response) {
      switch (error.response.status) {
        case 401:
          router.push('error/401');
        case 403:
          router.push('error/403');
      }
      //log(`服务器错误！ [${error.response.status}] ${error.response.data.message}`)
      // return Promise.reject(error.response)
      return {code:error.response.status , msg : error.response.data ? error.response.data.message : error.response}
      
    }else{
      log(`服务器错误！错误代码：${error}`)
      return {code : -2 , msg : ''}
    }
  }
)

service_raw.interceptors.response.use(
  response => response,

  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          router.push('error/401');
        case 403:
          router.push('error/403');
        default:
          log(`服务器错误！${error.response.status}`)
      }
      // return Promise.reject(error.response)
      return {code:error.response.status , msg : error.response.data ? error.response.data.message : error.response}
    }else{
      log(`服务器错误！${error}`)
      return {code : -2 , msg : ''}
    }
  }
)


const req = ({token , raw , url , method , data , params , headers , responseType } = {token:true , responseType:"json", raw : false , headers:{}}) => {

  let opts = { url , method , data, params , responseType , headers }

  if(token !== false){
    if(!opts.headers){
      opts.headers = {}
    }
    opts.headers['Authorization'] = `Bearer ${auth.getToken()}`
  }

  if(opts.headers['Content-Type'] == 'multipart/form-data'){
    opts.data = convFormData(opts.data)
  }

  return raw ? service_raw(opts) : service(opts)
  // return new Promise((resolve , reject) => {
  //   ( raw ? service_raw(opts) : service(opts) ).then(resp => {
  //     resolve(resp)
  //   }).catch((e)=>{
  //     resolve({code:-1})
  //   })
  // })
}

const request = (v) => {
  return request[v]
}


methods.forEach(method => {
 request[method] = ( url , data , opts = {} ) => req({
    url, method, data,
    headers: {
      "Content-Type": "application/json"
    },
    ...opts
  })
})


apis.forEach(([name , {url , data , access , ignoreData , clear, ...opts} , type = 'json'])=>{
  request[name] = (...args) => {
    let args_pre = [...args]
    if(access){
      args_pre.unshift(auth.getUserInfo().userType)
    }
    let params = {
      url : (typeof url === 'function' ? url(...args_pre) : url),
      ...opts
    }

    if( opts.method == 'get' && args.length && typeof url !== 'function'){
      params['params'] = args[0]
    }else{
      if(ignoreData !== true){
        params['data'] = args[0] || data
      }

      if( clear ){
        console.log('clear',clear)
        params.data = clearEmptyData(params.data , clear)
      }
    }

    params.headers = params.headers ||{}

    if(type == 'formdata'){
      params.headers['Content-Type'] = 'multipart/form-data'
    }else if(type == 'json'){
      params.headers['Content-Type'] = "application/json"
    }
    return req( params )
  }
  request[name+'Url'] = (d,raw) => ((raw ? baseURL : '') + ( typeof url === 'function' ? url(d) : url ))
})

request.mock = (data) => new Promise((resolve) => resolve({code:0 , data}))

const getReqHeaders = ()=>({Authorization:`Bearer ${auth.getToken()}`})

const getRequest = (id) => (request[id+'Url'])

// const getStaticPath = (path) => `${apiServer || '/api'}/public/${path}`
const getStaticPath = (path) => `${baseURL}/public/${path}`

export {
  baseURL , getReqHeaders  , getStaticPath
}

export default request